import { render } from "./index-instructor.vue?vue&type=template&id=73bb25b7"
import script from "./index-instructor.vue?vue&type=script&lang=js"
export * from "./index-instructor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__